export enum Roles {
  Admin = 'Admin',
  Reviewer = 'Reviewer',
  CompanyUser = 'CompanyUser',
}

export enum RoleLabels {
  Admin = 'Admin',
  CompanyUser = 'Company',
  CompanyAdmin = 'Company Admin',
  CompanyStandard = 'Company Standard',
  ReviewerStandard = 'Reviewer',
  ReviewerInternal = 'Internal',
}

export enum CompanyRoles {
  CompanyOwner = 'CompanyOwner',
  CompanyStandard = 'CompanyStandard',
}

export enum ReviewerRoles {
  ReviewerStandard = 'ReviewerStandard',
  ReviewerInternal = 'ReviewerInternal',
}
